import { __decorate, __extends } from "tslib";
import { Options } from 'vue-class-component';
import Nav from '@/components/common/Nav.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import CommonConfig from '@/common/CommonConfig';
import { PageService } from '@/views/copy/recharge/import';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.privilegeList = [];
        _this.showPopup = false; // 2022/3/1 17:52 安卓支付弹窗
        _this.rechargeForm = {
            radio: '1',
        }; // 2022/3/2 10:10 支付渠道选择
        _this.equipment = '';
        _this.vipData = {};
        _this.userInfo = {}; // 2022/3/2 16:20 用户详情  status 0 未开通 1 过期 2 vip
        _this.loading = false;
        _this.selectVip = {}; // 2022/3/2 17:01 选中的vip
        _this.activeIcon = '';
        _this.inactiveIcon = '';
        _this.isDiscount = false; // 2022/3/23 10:41 是否显示折扣
        _this.isShowProduct = false; // 2023/8/20 19:22  是否展示商品列表
        _this.isXty = false; // 2023/8/20 19:43  是否是第三方支付
        _this.payment = {
            wxpay: 1,
            alipay: 2,
            honorpay: 7,
        }; //  2024-06-17 10:28:40：支付方式
        return _this;
    }
    View.prototype.mounted = function () {
        var _this = this;
        this.loading = true;
        this.privilegeList = CommonConfig.Common.privilegeList;
        this.activeIcon = this.awlGlobalConfig.getH5ImgUrl('taoquvip/select1.png');
        this.inactiveIcon = this.awlGlobalConfig.getH5ImgUrl('taoquvip/select2.png');
        // 2022/3/2 15:44 获取设备信息
        this.equipment = this.awlGlobalConfig.isEquipmentEnvironment();
        this.getVip();
        window['doReloadData'] = function (result) {
            _this.doReloadData(result);
        };
    };
    // 2022/3/2 15:46 获取用户信息及会员状态
    View.prototype.getVip = function () {
        var _this = this;
        PageService.getVipData({
            os: this.equipment == 'Android' ? '1' : '2',
            // os: '1', //  2024-04-26 18:29:03：调试使用参数
            osv: this.awlGlobalState.urlInitParams.version,
            channel: this.equipment == 'Android' ? '' : 'apple',
        }).then(function (data) {
            _this.loading = false;
            _this.vipData = data;
            _this.rechargeForm.radio = data.platforms.length != 0 ? data.platforms[0].type : '';
            _this.userInfo = data.info;
            _this.selectVip = data.price.filter(function (item) {
                return item.isSelected;
            })[0];
            // this.isShowProduct = data.info.status != 2;
            if (!_this.selectVip) {
                _this.selectVip = _this.vipData.price[0];
            }
            _this.isDiscount = _this.equipment == 'IOS' && data.appConfig.imode == 2;
        });
    };
    // 2022/3/3 15:21 选择会员
    View.prototype.selectVipHandle = function (item) {
        this.selectVip = item;
    };
    // 判断是调用原生  还是 第三方支付方式
    View.prototype.isXtyPay = function () {
        var _this = this;
        PageService.payChannel({}).then(function (data) {
            if (Number(data.nativePay) === 1) {
                //原生支付
                // this.getRenewal();
                _this.isXty = false;
            }
            else {
                //第三方通道
                _this.isXty = true;
                // this.isShowProduct = true;
            }
        });
    };
    // 2022/3/2 15:38 会员特权
    View.prototype.getRenewal = function (type) {
        if (type === void 0) { type = 0; }
        this.payHandle();
        // 2022/3/2 15:40 判断是否是会员  0未开通 1过期 2vip
        //如果过期了 若是vip点击续费 则调用原生方法 显示原生弹窗  若不是则：安卓弹出弹窗  IOS调用原生
        // if (type === 1 && this.isXty) {
        //   this.isShowProduct = true;
        // } else {
        //   if (this.userInfo.status == 2 && !this.isXty) {
        //     // 2022/3/2 16:38 调用原生的方法 进行弹窗
        //     this.paySubmit();
        //   } else {
        //     this.payHandle();
        //   }
        // }
    };
    // 2022/3/2 15:45 判断是哪个设备 从而进行下一步判断
    View.prototype.payHandle = function () {
        // if (this.equipment == "IOS" && !this.isXty) {
        //   let params: any = {
        //     goodsId: this.selectVip.id,
        //     payMethod: Number(this.rechargeForm.radio),
        //     no: this.selectVip.no,
        //     action: 5, // 2022/3/14 19:18 5 代表会员支付
        //     renewVip: Boolean(this.userInfo.status == 2), // 2022/3/14 19:21 0 没开通过会员
        //   };
        //   this.awlGlobalConfig.messageHandlers(params);
        // } else {
        this.rechargeForm.radio = this.vipData.platforms.length != 0 ? this.vipData.platforms[0].type : '';
        this.showPopup = true;
        // }
    };
    // 2023/8/20 19:57 第三方支付
    View.prototype.genVipOrder = function () {
        var _this = this;
        console.log('支付');
        this.loading = true;
        // 2023/8/20 19:45 是第三方支付
        PageService.genVipOrder({
            goodsId: this.selectVip.id,
            payMethod: this.payment[this.rechargeForm.radio],
        })
            .then(function (data) {
            _this.loading = false;
            window.location.href = data.payData;
        })
            .catch(function () {
            _this.loading = false;
        });
    };
    // 2022/3/2 16:44 调用原生支付方法
    View.prototype.paySubmit = function () {
        // if (this.isXty) {
        //   if (!this.loading) {
        //     this.genVipOrder();
        //   }
        // } else {
        var params = {
            goodsId: this.selectVip.id,
            payMethod: this.payment[this.rechargeForm.radio],
            action: 5,
            no: this.selectVip.no,
            renewVip: Boolean(this.userInfo.status == 2),
        };
        console.log('原生支付：', params);
        this.awlGlobalConfig.messageHandlers(params);
        // }
    };
    // 2022/3/2 17:16 原生调用H5方法
    View.prototype.doReloadData = function (result) {
        // this.rechargeForm.radio = '1'
        this.showPopup = false;
        this.getVip();
    };
    // 2023/11/27 16:33  跳转会员协议页面
    View.prototype.toMemberShip = function () {
        var param = {
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            mark: this.awlGlobalState.urlInitParams.mark,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/membership',
            query: param,
        });
    };
    View = __decorate([
        Options({
            components: { Nav: Nav },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
